export const SET_RESULTS_FOR_POOL_REQUEST = 'SET_RESULTS_FOR_POOL_REQUEST';

export const setResultsForPoolRequest = ( resultEntryIds ) => ({
    type: SET_RESULTS_FOR_POOL_REQUEST,
    payload: {
        resultEntryIds,
    }
});
